import styled from 'styled-components';

const StyledHeroParallax = styled.div`
  position:  relative;
  margin: 40px 16px ${props => props.theme.components_spacing_desk.xxlarge}px;
  text-align: center;
  height: 100vh;
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  .parallax--wrap{
    position: absolute;
    width: 110%;
    height: 110%;
    top: -5%;
    left: -5%;
    z-index: 1;
  }
  .parallax--item {
    position: absolute;
    width: 310px;
    height: 204px;
  }
  .pos-1{
    top: 10%;
    left: 0;
  }
  .pos-2{
    top: 0;
    right: 10%;
  }
  .pos-3{
    bottom: 0%;
    left: 10%;
  }
  .pos-4{
    bottom: 10%;
    right: 0;
  }
  .parallax--item-img {
    position: relative;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: 50% 50%;
  }
  .text--wrap{
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    color: #fff;
    z-index: 2;
  }
  .text--wrap h5{
    margin-bottom: 35px;
  }
  .text--wrap p {
    color: ${props => props.theme.colors.green_secondary};
  }

  .text--wrap img{
    width: 16px;
  }
  @media screen and (max-width: 1439px){
    
  }
  @media screen and (max-width: 1023px){
    margin-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    .parallax--item {
      width: 210px;
      height: 138px;
    }
  }
  @media screen and (max-width: 767px){
    margin: 24px 8px ${props => props.theme.components_spacing_mobile.xxlarge}px;
    .parallax--wrap{
      
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 1;
    }
    .pos-1{
      top: -4%;
      left: -35%;
    }
    .pos-2{
      top: 10%;
      right: -25%;
    }
    .pos-3{
      bottom: 0%;
      left: -30%;
    }
    .pos-4{
      bottom: 9%;
      right: -25%;
    }
  }
`;
export {
  StyledHeroParallax,
};

